module.exports = __webpack_public_path__ + "static/teddy1-b8bf68d00d6410185ca8c8303286f95a.png";